import moment from "moment";

const VISIT_DATE_KEYS = ["date", "in", "out"];

/** Convierte fechas de visita a ISO string para Redux (estado serializable). */
export const serializeVisitDates = (visit) => {
  if (!visit) return visit;

  const next = { ...visit };
  VISIT_DATE_KEYS.forEach((key) => {
    const value = next[key];
    if (value == null || value === "") return;
    if (moment.isMoment(value)) {
      next[key] = value.toISOString();
      return;
    }
    if (value instanceof Date) {
      next[key] = value.toISOString();
      return;
    }
    if (typeof value === "string" && moment(value).isValid()) {
      next[key] = moment(value).toISOString();
    }
  });
  return next;
};
